/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */
if (!window['structuredClone']) {
	window.structuredClone = function <T = unknown>(obj: unknown): T {
		console.log('using polyfill structuredClone');
		if (obj === undefined || obj === null) {
			return obj;
		}
		return JSON.parse(JSON.stringify(obj));
	};
}
if (!Object['groupBy']) {
	Object['groupBy'] = function <T = unknown>(items: Iterable<T>, callback: (item: T, index: number) => PropertyKey): Partial<Record<PropertyKey, T[]>> {
		if (typeof callback !== 'function') throw new Error('callback must be a function');
		if (!items || typeof items[Symbol.iterator] !== 'function') throw new Error('items must be an iterable');
		const result: Partial<Record<PropertyKey, T[]>> = Object.create(null);
		let index = 0;
		for (const item of items) {
			const key = callback(item, index++);
			if (!result[key]) {
				result[key] = [];
			}
			result[key].push(item);
		}
		return result;
	};
}

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
